import React, { Component } from 'react';
import { FA } from 'widgets/default/FA';

class TextFieldEdit extends Component {
  state = {
    valid: true,
    editing: false,
    errorMessage: ""
  }

  handleClick = () => {
    this.setState({editing: true}, () => this.inputBox.focus());
  }

  handleBlur = () => {
    this.save();
  }

  handleKeyDown = (e) => {
    if(e.keyCode == 13) {
      this.save(false);
    }
    if(e.keyCode == 27) {
      this.save(true);
    }
  }

  onChange = (evt) => {
    this.validate();
    this.props.onChange(evt);
  }

  validate() {
    var valid = true, message=true;

    if (!this.inputBox) return true;
    var value = this.inputBox.value;

    if(this.props.validator) {
      message = this.props.validator(this.inputBox.value);
    }

    if(message !== true) {
      this.setState({errorMessage: message});
    } else {
      this.setState({errorMessage: ""});
    }

    valid = (message === true);

    this.setState({valid: valid});
    return valid;
  }

  save(cancel=false) {
    // ensure validatation is up to date
    this.validate();
    this.setState({editing: false});

    // force cancel if trying to save invalid data
    cancel = cancel || !this.state.valid;

    // reset error message if cancelled
    if(cancel) {
      this.setState({valid: true, errorMessage: ""})
    };
    this.props.handleSave(this.props.name,cancel);
  }

  render() {
    var styles = {
      textAlign: "right",
      fontSize: "14px",
      color: "#000"
    };
    var errorStyles = {
      color: "#f00"
    };
    if(this.state && this.state.valid===false) {
      styles['border'] = '1px solid #ff0000';
      styles['color'] = '#ff0000';
    } else {
      styles['border'] = '';
    }
    if(this.state && this.state.editing) {
      return (
        <span className="pull-right">
          <span className="errorMessage" style={errorStyles}>
            {this.state.errorMessage}{' '}
        </span>
        <input
          style={styles}
          ref={(node) => this.inputBox = node}
          type="text"
          value={this.props.value}
          onChange={this.onChange}
          onBlur={this.handleBlur}
          onKeyDown={this.handleKeyDown}
        />
        </span>
      );
    } else {
      var val = this.props.value ? this.props.value : "\[EMPTY\]";
      return (<span onClick={this.handleClick} className="pull-right"><span>{val}</span>{' '}<FA name="pencil" /></span>);
    }
  }
}

export { TextFieldEdit };
